import axios from 'axios'

// let apiUrl = 'https://costa-sol-rent-sandbox.herokuapp.com/api'
let isDev = false
if (process.env.NODE_ENV === 'development') {
  isDev = true
} else {
  axios.defaults.withCredentials = true
}

export default {
  sortList (apiUrl, module, sort) {
    this.apiPutRequest(apiUrl, '/sort/' + module, sort)
  },

  toggleBooleanValue (apiUrl, moduleName, id, field, newValue) {
    let data = {}
    data[field] = newValue
    return new Promise((resolve) => {
      this.apiPutRequest(apiUrl, '/' + moduleName + '/' + id, data).then((response) => {
        resolve(response)
      })
    })
  },

  saveItem (apiUrl, moduleName, data) {
    return new Promise((resolve) => {
      if (data._id) {
        this.apiPutRequest(apiUrl, '/' + moduleName + '/' + data._id, data).then((response) => {
          resolve(response)
        })
      } else {
        this.apiPostRequest(apiUrl, '/' + moduleName, data).then((response) => {
          resolve(response)
        })
      }
    })
  },

  login (apiUrl, username, password) {
    return new Promise((resolve) => {
      axios.post(apiUrl + '/login', {
        username: username,
        password: password
      }, this.sendHeaders()).then((response) => {
        if (response.data) {
          resolve(response.data)
        }
        resolve({})
      }).catch((error) => {
        resolve(error.response.data)
      })
    })
  },

  logout (apiUrl) {
    return new Promise((resolve) => {
      axios.get(apiUrl + '/logout', this.sendHeaders()).then((response) => {
        if (response.data) {
          resolve(response.data)
        }
        resolve({})
      }).catch((error) => {
        resolve(error.response.data)
      })
    })
  },

  deleteItem (apiUrl, moduleName, itemId) {
    return new Promise((resolve) => {
      this.apiDeleteRequest(apiUrl, '/' + moduleName + '/' + itemId).then((response) => {
        resolve(response)
      })
    })
  },

  checkSession (apiUrl) {
    return this.apiRequest(apiUrl, '/session', [])
  },

  getOneItem (apiUrl, moduleName, itemId) {
    if (itemId === '0' || itemId === null) {
      return new Promise((resolve) => {
        resolve({})
      })
    }
    return this.apiRequest(apiUrl, '/' + moduleName + '/' + itemId, [])
  },

  getOneItemWithFilters (apiUrl, moduleName, itemId, filters) {
    if (itemId === '0' || itemId === null) {
      return new Promise((resolve) => {
        resolve({})
      })
    }
    return this.apiRequest(apiUrl, '/' + moduleName + '/' + itemId, filters)
  },

  getListItemsToStore (apiUrl, moduleName, filters) {
    return this.apiRequest(apiUrl, '/' + moduleName, filters)
  },

  getListItems (apiUrl, moduleName, filters) {
    return this.apiRequest(apiUrl, '/' + moduleName, filters)
  },

  getModulesWithFields (apiUrl) {
    return this.apiRequest(apiUrl, '/allmodulefields', [])
  },

  apiRequest (apiUrl, url, filters) {
    return new Promise((resolve) => {
      axios.get(apiUrl + url + '?' +
        filters.map(
          filter => filter.key + '=' + filter.value
        ).join('&'), this.sendHeaders()).then((response) => {
        if (response.data) {
          resolve(response.data)
        }
        resolve({})
      }).catch((error) => {
        resolve(error)
      })
    })
  },

  apiPostRequest (apiUrl, url, postData) {
    return new Promise((resolve) => {
      axios.post(apiUrl + url, postData, this.sendHeaders()).then((response) => {
        if (response.data) {
          resolve(response.data)
        }
        resolve({})
      }).catch((error) => {
        resolve(error)
      })
    })
  },

  apiPutRequest (apiUrl, url, postData) {
    Object.keys(postData).forEach(key => {
      if (postData[key] === undefined) {
        postData[key] = null // Axios is not sending undefined
      }
    })
    return new Promise((resolve) => {
      axios.put(apiUrl + url, postData, this.sendHeaders()).then((response) => {
        if (response.data) {
          resolve(response.data)
        }
        resolve({})
      }).catch((error) => {
        resolve(error)
      })
    })
  },

  apiDeleteRequest (apiUrl, url, postData) {
    return new Promise((resolve) => {
      axios.delete(apiUrl + url, this.sendHeaders()).then((response) => {
        if (response.data) {
          resolve(response.data)
        }
        resolve({})
      }).catch((error) => {
        resolve(error)
      })
    })
  },

  sendHeaders () {
    let headers = {}
    if (!isDev) {
      headers.withCredentials = true
    }
    return headers
  }
}
